<template>
  <div class="finance-daily ls-card">
    <!-- 顶部工具栏 -->
    <div class="toolbar">
      <el-radio-group v-model="period" size="small" @change="loadData">
        <el-radio-button label="week">近7天</el-radio-button>
        <el-radio-button label="month">近30天</el-radio-button>
      </el-radio-group>
      <div class="toolbar-right">
        <el-button
          type="default"
          size="small"
          icon="el-icon-refresh"
          :loading="loading"
          @click="loadData"
        >刷新</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          :disabled="tableData.length === 0"
          @click="exportExcel"
        >导出 Excel</el-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column prop="dateStr" label="日期" min-width="110"></el-table-column>
      <el-table-column prop="order_count" label="新增工单" width="100" align="right"></el-table-column>
      <el-table-column prop="completed_count" label="完结工单" width="100" align="right"></el-table-column>
      <el-table-column label="应收收入" width="120" align="right">
        <template slot-scope="scope">¥{{ scope.row.revenue_total }}</template>
      </el-table-column>
      <el-table-column label="实收收入" width="120" align="right">
        <template slot-scope="scope">¥{{ scope.row.revenue_paid }}</template>
      </el-table-column>
      <el-table-column label="总成本" width="120" align="right">
        <template slot-scope="scope">¥{{ scope.row.cost_total }}</template>
      </el-table-column>
      <el-table-column label="利润" width="120" align="right">
        <template slot-scope="scope">
          <span :class="{ 'text-danger': parseFloat(scope.row.profit) < 0 }">
            ¥{{ scope.row.profit }}
          </span>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="tableData.length === 0 && !loading" class="empty-tip">暂无数据</div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import dayjs from 'dayjs'
import { apiFinanceTrend } from '@/api/work_order_finance'

export default {
  name: 'FinanceDaily',
  data () {
    return {
      period: 'week',
      loading: false,
      rawData: []
    }
  },
  computed: {
    tableData () {
      // 后端返回升序，展示时翻转为降序（最新在上）
      return [...this.rawData]
        .reverse()
        .map(row => ({
          ...row,
          dateStr: dayjs.unix(row.date).format('YYYY-MM-DD')
        }))
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      apiFinanceTrend({ period: this.period })
        .then(data => { this.rawData = data || [] })
        .finally(() => { this.loading = false })
    },
    exportExcel () {
      const rows = this.tableData.map(row => ({
        日期: row.dateStr,
        新增工单: row.order_count,
        完结工单: row.completed_count,
        应收收入: parseFloat(row.revenue_total),
        实收收入: parseFloat(row.revenue_paid),
        总成本: parseFloat(row.cost_total),
        利润: parseFloat(row.profit)
      }))
      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '日报明细')
      const fileName = `财务日报_${this.period === 'week' ? '近7天' : '近30天'}.xlsx`
      XLSX.writeFile(wb, fileName)
    }
  }
}
</script>

<style lang="scss" scoped>
.finance-daily {
  padding: 20px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.empty-tip {
  text-align: center;
  color: #909399;
  padding: 20px 0;
  font-size: 14px;
}

.text-danger {
  color: #F56C6C;
}
</style>
